import { render, staticRenderFns } from "./Garden.vue?vue&type=template&id=4199c6ab&"
import script from "./Garden.vue?vue&type=script&lang=js&"
export * from "./Garden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports